module.exports = __webpack_public_path__ + "static/media/sunday_times.8ba962c4.png";